'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoSplit = function GoSplit(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm17.5 10l-10-10-7.5 7.5 12.1 11.7c0.6-3.1 1.7-5.3 5.2-9l0.2-0.2z m5-10l5.2 5.2-7.7 7.7c-3.9 3.9-5 6.3-5 12.1v15h10v-15c0-2.1 0.7-3.7 2.1-5l7.7-7.7 5.2 5.2v-17.5h-17.5z' })
        )
    );
};

exports.default = GoSplit;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/go/split.js
// module id = 2013
// module chunks = 0